import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

/*
 * No `name` on purpose: that makes the extension id `sign-in-page:app`, which
 * REPLACES the one @backstage/plugin-app provides by default. A named
 * extension would be a second one on a singleton input, and the app would fail
 * to start with "Expected bootstrap tree to expose a root element".
 */
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => import('./SignInPage').then(m => m.SignInPage),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
